import { render, staticRenderFns } from "./ProjectDetailsForm.vue?vue&type=template&id=d6f53b12&scoped=true&"
import script from "./ProjectDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsForm.vue?vue&type=style&index=0&id=d6f53b12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f53b12",
  null
  
)

export default component.exports